import { DATABASE } from '../../constants/Constant'
import { getDocument } from './firebaseCliDaoMethods'

const getClientLatestVersion = () => {
  console.log('inside getClientLatestVersion ')
  return new Promise((resolve) => {
    let colPath = DATABASE.CLIENT_CONFIG_COL
    getDocument(colPath, DATABASE.APP_LATEST_VERSIONS_DOC)
      .then((doc) => {
        if (doc.exists) {
          let obj = doc.data()
          resolve(obj['com.zebra.mdna'])
        }
        resolve(null)
      })
      .catch((e) => {
        console.log('Error: while creating deployment for update client:' + JSON.stringify(e))
        resolve(null)
      })
  })
}

const getAppLatestVersions = () => {
  console.log('inside getAppLatestVersions ')
  return new Promise((resolve) => {
    let colPath = DATABASE.CLIENT_CONFIG_COL
    getDocument(colPath, DATABASE.APP_LATEST_VERSIONS_DOC)
      .then((doc) => {
        if (doc.exists) {
          let obj = doc.data()
          resolve(obj)
        }
        resolve(null)
      })
      .catch((e) => {
        console.log('Error: while creating deployment for update client:' + JSON.stringify(e))
        resolve(null)
      })
  })
}

const getVideoAndBannerReferences = () => {
  return new Promise(function (resolve, reject) {
    const clientConfigCol = `/${DATABASE.CLIENT_CONFIG_COL}/`

    return Promise.allSettled([getDocument(clientConfigCol, DATABASE.DEMO_VIDEOS_REFERENCE), getDocument(clientConfigCol, DATABASE.RELEASED_FEATURE_DETAILS)])
      .then((promiseArr) => {
        let errorArr = []
        promiseArr.map((item) => (item.status === 'rejected' ? errorArr.push(item.reason) : null))
        if (errorArr.length === 0) {
          let videos =
            promiseArr[0].value.data() && promiseArr[0].value.data().videos
              ? promiseArr[0].value.data().videos
              : []
          let releasedFeatureDetails =
            promiseArr[1].value.data() && promiseArr[1].value.data().whatsNewBanner
              ? promiseArr[1].value.data().whatsNewBanner
              : []
          resolve({ result: { videos: videos, releasedFeatureDetails: releasedFeatureDetails } })
        } else {
          console.log('Error while fetching getVideoAndBannerReferences, Error: ' + errorArr)
          resolve([])
        }
      })
      .catch((err) => {
        console.log(
          'Error while fetching getVideoAndBannerReferences, Error: ' + JSON.stringify(err)
        )
        resolve([])
      })
  })
}

export { getClientLatestVersion, getVideoAndBannerReferences, getAppLatestVersions }
